<div *ngIf="isLoading" class="loading-container">
  <qai-loading [size]="'medium'"></qai-loading>
</div>

<div class="tab-content" *ngIf="!isLoading && isTranslationLoaded">
  <div class="practice-content">
    <qai-item-grid
      gap="24px"
      minItemWidth="280px"
      repeatCount="auto-fit"
      class="summary-grid"
    >
      <div class="summary-card">
        <div class="card-value">{{ practiceAssignmentCount }}</div>
        <div class="card-label">{{ 'reportingV2.TOTAL_PRACTICE_ASSIGNMENTS' | transloco }}</div>
      </div>

      <div class="summary-card">
        <div class="card-value">{{ averageSessionsPerAssignment }}</div>
        <div class="card-label">{{ 'reportingV2.AVG_SESSIONS_PER_ASSIGNMENT' | transloco }}</div>
      </div>
      
      <div class="summary-card">
        <div class="card-value engaged">{{ assignmentsEngagedRatio }}</div>
        <div class="card-label">{{ 'reportingV2.ASSIGNMENTS_ENGAGED_WITH' | transloco }}</div>
      </div>
      
      <div class="summary-card">
        <div class="card-value">{{ averageImprovementPercent }}%</div>
        <div class="card-label">{{ 'reportingV2.AVERAGE_IMPROVEMENT' | transloco }}</div>
      </div>
    </qai-item-grid>

    <qai-table
      [headers]="headers"
      [data]="tableData"
      [striped]="false"
      [currentPage]="currentPage"
      [showPagination]="true"
      [pageSize]="3"
      [currentPage]="1"
      [initialSortColumn]="initialSortColumn"
      [initialSortDirection]="initialSortDirection"
      (pageChanged)="onPageChanged($event)"
      [noDataMessage]="'reportingV2.NO_ASSIGNMENTS' | transloco"
    ></qai-table>
  </div>
</div>
